<template>
  <div v-infinite-scroll="load" infinite-scroll-disabled="busy" class="news-list">
    <div v-for="(item, index) in data" :key="index" class="list-item" @click="$emit('to', item)">
      <div :class="['item-title', 'two-line', visited.includes(item.id ?? item.noticeId) ? 'visited' : '']">
        {{ item[fields.title] }}
      </div>
      <div class="item-time">
        <slot name="bottom" :item="item">{{ $funs.timeFormatByFromNow(item[fields.time]) }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'

export default {
  directives: { infiniteScroll },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    visited: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default: () => {}
    },
    busy: {
      types: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    fields() {
      return {
        id: 'id',
        title: 'title',
        time: 'time',
        ...this.props
      }
    }
  },
  methods: {
    load() {
      this.$emit('load')
    }
    // timeFormatter(time) {

    // }
  }
}
</script>

<style lang="scss" scoped>
.news-list {
  margin-top: 8px;
  .list-item {
    padding: 10px;
    border-bottom: 1px solid var(--border-color-1);
    overflow: hidden;
  }
  .item-title {
    line-height: 22px;
    font-size: 14px;
    word-break: break-all;
    &.visited {
      color: var(--font-color-3); /*已访问的链接颜色*/
    }
  }
  .item-time {
    padding-top: 10px;
    font-size: 12px;
    color: var(--font-color-3);
  }
}
</style>
